import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiAlertTriangle } from "react-icons/fi";

export default function PaymentUnavailableModal({ show, handleClose }) {
  const handleRedirect = () => {
    window.open("https://www.vozohealth.com/talk-to-us", "_blank");
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      {/* Header */}
      <Modal.Header
        closeButton
        className="border-0 pb-0 pt-3 px-3 justify-content-end"
      />

      {/* Body */}
      <Modal.Body className="text-center px-4 pb-4 pt-2">
        {/* Icon */}
        <div className="mb-2">
          <FiAlertTriangle size={40} className="text-warning" />
        </div>

        {/* Title */}
        <h5 className="fw-bold text-dark mb-2" style={{ fontSize: "19px" }}>
          Payment service temporarily unavailable
        </h5>

        {/* Description */}
        <p
          className="text-muted mb-3"
          style={{
            fontSize: "14.5px",
            lineHeight: "1.6",
            maxWidth: "340px",
            margin: "0 auto",
            textAlign: "center",
            display: "flex",
          }}
        >
          Our payment gateway is currently under maintenance. To upgrade your
          plan or make a purchase, please contact our sales team.
        </p>

        {/* Button */}
        <div className="d-flex justify-content-center mt-2">
          <Button
            onClick={handleRedirect}
            className="fw-semibold"
            style={{
              borderRadius: "10px",
              padding: "9px 20px",
              fontSize: "14px",
              background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
              border: "none",
            }}
          >
            Talk to Sales
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
